/**
 * extract a content item name and variant from a forceContent option value
 * @param forceContent
 */
export function getForcedContentData(forceContent: string): { name?: string, variant?: string } {
  if (typeof forceContent !== 'string') {
    return {}
  }

  forceContent = forceContent.toLowerCase()

  if (!forceContent.startsWith('urn:upp:')) {
    // not a valid UPP URN
    return {
      name: forceContent,
    }
  }
  const split = forceContent.split(':').slice(2)

  if (split[0].startsWith('leadgen')) {
    // special case for lead generation layer (layer name/variant does not match URN)
    return {
      name: 'lead-generation-layer',
      variant: split[0].split('/').slice(1).join('/'),
    }
  }

  return {
    name: split[0],
    variant: split[1],
  }
}
